import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { Modal } from 'react-bootstrap'

import style from './style.css'

export default function EbookModal (props) {
  return (
    <div data-test-id="ebookModal">
      <Modal show={true} className={classnames(style.modalContainer)}>
        <Modal.Header className={classnames('modal-header', style.headerContainer)}>
          <Modal.Title>To read about this topic, go to your textbook:</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className={style.content} dangerouslySetInnerHTML={{ __html: props.data }} />
        </Modal.Body>
        <Modal.Footer className={classnames('modal-footer', style.footerContainer)}>
          <button
            data-test-id="ebookModalBtn"
            aria-label="Close message"
            className={classnames('btn-cdl-main')}
            onClick={props.onClick}
          >
            OK
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

EbookModal.propTypes = {
  onClick: PropTypes.func.isRequired,
  data: PropTypes.string.isRequired
}
